import { signedFetch } from './client';

export interface ResourceStatusResult {
  status: 'healthy' | 'degraded' | 'not_found' | 'unknown';
  lastChecked: string;
  details?: Record<string, unknown>;
  error?: string;
}

export interface ResourceStatusResponse {
  resources: Record<string, ResourceStatusResult>;
  errors: Record<string, ResourceStatusResult>;
}

export async function getResourceStatus(arns: string[]): Promise<ResourceStatusResponse> {
  const encoded = arns.map(a => encodeURIComponent(a)).join(',');
  const { data } = await signedFetch('GET', `/resources/status?arns=${encoded}`);
  return data as ResourceStatusResponse;
}
